import React from 'react';
import { ColumnDefinitionEnum, BoloQueueView } from '@mark43/cad-api';
import { WorkspaceQueueColumn } from '../../panels/workspace-queue-column';
import columnDefinitionEnum from '../../queues/column-definition.enum';
import { PriorityBox } from '../../common/components/fr-queues/priority-box';
import { BaseCellStyledBox } from '../../common/components/fr-queues/base-cell-styled-box';
import { FrTooltipCell } from '../../common/components/fr-queues/fr-tooltip-cell';
import { cssVar } from '@cad-arc';
import { Mask } from '../../common/components/datadog-privacy';

export const FrBoloCompactQueueCell = ({
    col,
    data,
}: {
    col: WorkspaceQueueColumn;
    data: BoloQueueView;
}) => {
    const item = columnDefinitionEnum[col.columnDefinition];

    if (item.name === ColumnDefinitionEnum.BOLO_PRIORITY.name) {
        return (
            <Mask>
                <BaseCellStyledBox
                    $fontSize={cssVar('arc.fontSizes.sm')}
                    $padding={cssVar('arc.space.half')}
                    borderRadius={cssVar('arc.radii.base')}
                >
                    <PriorityBox isFlashing={data.isPriority1}>
                        {data.priorityAbbreviation}
                    </PriorityBox>
                </BaseCellStyledBox>
            </Mask>
        );
    }

    return <Mask><FrTooltipCell text={item.getFlatValue(data)} /></Mask>;
};
